import { Pressable, View, Image, Platform } from "react-native";
import React, { memo, useEffect, useState } from "react";
import moment from "moment";
import { useNavigation } from "@react-navigation/native";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import dimensions from "../../../../../globalStyles/dimensions";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import CustomComponent from "../../../../../components/CustomComponent";

type ReviewProps = {
  item: {
    description: string;
    img: string;
    name: string;
    time: string;
  };
};

const Review: React.FC<ReviewProps> = ({ item }: { item: any }) => {
  const navigation = useNavigation();

  const [timeDifference, setTimeDifference] = useState<string>("");

  useEffect(() => {
    setTimeDifference(moment(item.time).fromNow());
  }, [item.time]);

  const shadowStyle =
    Platform.OS === "ios"
      ? {
          shadowColor: Colors.black100,
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.3,
          shadowRadius: 4,
        }
      : Platform.OS === "android"
      ? {
          elevation: 2,
        }
      : {
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: 0.1,
          shadowRadius: 10,
          elevation: 1,
        };

  const renderReviewDescription = () => {
    const description = item.description;
    if (description.length > 70) {
      return (
        <>
          <CustomComponent.TextView
            title={`${description.slice(0, 130)}...`}
            textStyle={[GlobalStyles.bodyText,{
              opacity: 0.5,
            }]}
          />
          <View
            style={{
              width: Platform.OS === "web" ? 90 : dimensions.windowWidth / 4.5,
            }}
          >
            <CustomComponent.TextView
              title={"Read more"}
              textStyle={[
                GlobalStyles.bodyText,
                {
                  color: Colors.gold10,
                  borderBottomWidth: 1,
                  borderBottomColor: Colors.gold10,
                },
              ]}
            />
          </View>
        </>
      );
    } else {
      return (
        <CustomComponent.TextView
          title={description}
          textStyle={GlobalStyles.bodyText}
        />
      );
    }
  };

  return (
    <Pressable
      onPress={() => navigation.navigate("experiences-review" as never)}
    >
      <View
        style={{
          width: 300,
          height: 220,
          paddingHorizontal:
            Platform.OS === "ios" || Platform.OS === "android"
              ? dimensions.paddingHorizontal
              : Platform.OS === "web"
              ? 20
              : dimensions.paddingHorizontal,
          paddingVertical: 15,
          gap: 10,
          borderRadius: 8,
          backgroundColor: Colors.white000,
          shadowColor: Colors.black100,
          ...shadowStyle,
        }}
      >
        {renderReviewDescription()}
        <View
          style={{
            position: "absolute",
            bottom: 0,
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
            paddingBottom: dimensions.paddingVertical,
            paddingHorizontal:
              Platform.OS === "web" ? 0 : dimensions.paddingHorizontal,
          }}
        >
          <Image
            source={{
              uri: item.image,
            }}
            style={{ width: 40, height: 40, borderRadius: 50 }}
          />
          <View>
            <CustomComponent.TextView
              title={item.name}
              textStyle={GlobalStyles.bodyTextBold}
            />
            <CustomComponent.TextView
              title={timeDifference}
              textStyle={GlobalStyles.captionText}
            />
          </View>
        </View>
      </View>
    </Pressable>
  );
};

export default memo(Review);
